import { useContext } from 'react';
import React from 'react';

import {
	createBrowserRouter as newRouter, // createHashRouter as newRouter,
	redirect,
} from 'react-router-dom';
import { Navigate, useRoutes } from 'react-router-dom';

import App from './App';
import { UserContext } from './App';
import DashboardLayout from './layouts/dashboard';
import OnBoardingLayout from './layouts/onboarding';
import SubscriptionLayout from './layouts/subscription';
import SubscriptionPlans from './layouts/subscription/SubscriptionForms';
import NotFound from './pages/404';
import CopilotPage from './pages/app/copilot';
import CopilotSubscribe from './pages/app/copilot/subscribe';
import { CopilotCompletion } from './pages/app/copilot/subscribe/CopilotCompletion';
import Dashboard from './pages/app/dashboard';
import ComingSoon from './pages/app/dashboard/coming-soon';
import ContentMonitor from './pages/app/dashboard/content-monitor';
import SingleContentMonitorList from './pages/app/dashboard/content-monitor/SingleList';
import SingleContentMonitor from './pages/app/dashboard/content-monitor/SingleMonitor';
import Creators from './pages/app/dashboard/creators';
import CreatorReport2 from './pages/app/dashboard/creators/creator/report-new';
import ProductMainMenuPage from './pages/app/dashboard/product-main-menu';
import QuestionsAnswers from './pages/app/dashboard/qa-collections';
import Reports from './pages/app/dashboard/reports';
import SemanticSearch from './pages/app/dashboard/semantic-search';
import UnauthorizedView from './pages/app/dashboard/unauthorized';
import VideoDataLake from './pages/app/dashboard/video-data-lake';
import SingleCategoryPage from './pages/app/dashboard/video-data-lake/single-category';
import Creator from './pages/app/dashboard/video-data-lake/single-category/Creator';
import VideoInsightsCoPilot from './pages/app/dashboard/video-insights-co-pilot';
import Collections from './pages/app/dashboard/video-insights-co-pilot/collections';
import VideoIntelligenceOnDemand from './pages/app/dashboard/video-intelligence-on-demand';
import { ActivityHistory } from './pages/app/settings/activityhistory';
import Billing from './pages/app/settings/billing/view';
import OrganizationInfo from './pages/app/settings/organisation/view';
import ProfileSettings from './pages/app/settings/profile-settings/view';
import UsersView from './pages/app/settings/users/view';
import Subscribe from './pages/app/subscribe';
import SubscribeTopUp from './pages/app/subscribe-top-up';
import { Completion } from './pages/app/subscribe/Completion';
import ConfirmRegister from './pages/auth/confirm';
import JoinTeam from './pages/auth/join';
import Login from './pages/auth/login';
import Register from './pages/auth/register';
import ResetPassword from './pages/auth/reset-password';
import OnBoarding from './pages/onboarding';
import { CollectionsContextProvider } from './providers/CollectionsContextProvider';

// Import your UserContext
const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({
	children,
}) => {
	const { isAdmin } = useContext(UserContext);

	return isAdmin ? <>{children}</> : <UnauthorizedView />;
};

export const router = newRouter([
	// ENTRYPOINT REDIRECT
	{
		index: true,
		loader: async () => {
			throw redirect('/app/dashboard/product-main-menu');
		},
	},

	// AUTH
	{
		path: '/auth',
		element: <OnBoardingLayout />,
		children: [
			{ path: 'login', element: <Login /> },
			{ path: 'register', element: <Register /> },
			{ path: 'confirm', element: <ConfirmRegister /> },
			{ path: 'join', element: <JoinTeam /> },
			{ path: 'reset-password', element: <ResetPassword /> },
		],
	},

	// APP
	{
		path: '/app',
		element: <App />,
		children: [
			// ONBOARDING
			{
				element: <OnBoardingLayout />,
				path: 'setup',
				children: [
					{
						index: true,
						element: <OnBoarding />,
					},
				],
			},
			{
				element: <DashboardLayout />,

				children: [
					{
						index: true,
						element: <Subscribe />,
					},
					{
						path: 'completion',
						element: <Completion />,
					},
				],
				path: 'subscribe',
			},

			{
				element: <DashboardLayout />,

				children: [
					{
						index: true,
						element: <SubscribeTopUp />,
					},
				],
				path: 'subscribe-top-up',
			},
			// // SUBSCRIPTIONS
			// {
			// 	element: <SubscriptionLayout />,
			// 	path: 'subscriptions',
			// },

			// DASHBOARD
			{
				element: <DashboardLayout />,
				// index: true,
				path: 'dashboard',
				children: [
					{
						index: true,

						loader: async () => {
							throw redirect('/app/dashboard/product-main-menu');

							// throw redirect('/app/dashboard/creators');
						},
					},
					{
						path: 'product-main-menu',
						element: <ProductMainMenuPage />,
					},
					{
						path: 'video-intelligence-lake',
						element: <VideoDataLake />,
					},
					{
						path: 'video-intelligence-lake/:categoryId/creators/:id',
						element: <Creator />,
					},
					{
						path: 'video-intelligence-lake/:id',
						element: <SingleCategoryPage />,
					},
					{
						path: 'semantic-search',
						element: <SemanticSearch />,
					},
					{
						path: 'video-intelligence-on-demand',
						element: <VideoIntelligenceOnDemand />,
					},
					{
						path: 'video-insights-co-pilot',
						element: (
							<CollectionsContextProvider>
								<VideoInsightsCoPilot />
								<></>
							</CollectionsContextProvider>
						),
					},
					{
						path: 'video-insights-co-pilot/collections',
						element: (
							<CollectionsContextProvider>
								<Collections />
								<></>
							</CollectionsContextProvider>
						),
					},
					{
						path: 'video-insights-co-pilot/collections/:type',
						element: (
							<CollectionsContextProvider>
								<Collections />
								<></>
							</CollectionsContextProvider>
						),
					},
					{
						path: 'video-insights-co-pilot/collections/:type/:id',
						element: (
							<CollectionsContextProvider>
								<Collections />
								<></>
							</CollectionsContextProvider>
						),
					},
					{
						path: 'content-monitor',
						element: <ContentMonitor />,
					},
					{
						path: 'content-monitor/:id',
						element: <SingleContentMonitor />,
					},
					{
						path: 'content-monitor/:id/list-history/:list_id',
						element: <SingleContentMonitorList />,
					},
					{
						path: 'creators',
						element: <Creators />,
					},

					{
						path: 'qa-collections',
						element: <QuestionsAnswers />,
					},
					// {
					// 	path: 'reports',
					// 	element: <Reports />,
					// },
					// {
					// 	path: 'creators/:id/report',
					// 	element: <CreatorReport />,
					// },
					{
						path: 'creators/:id/report-v2',
						element: <CreatorReport2 />,
					},
					{
						path: 'users',
						element: (
							<ProtectedRoute>
								<UsersView />
							</ProtectedRoute>
						),
					},
					{
						path: 'files',
						element: <ComingSoon />,
					},
					// TODO: uncomment
					{
						path: 'activity',
						element: <ComingSoon />, // TODO: Wrap in <ProtectedRoute> when ready
						// element: <ActivityHistory />,
					},
					{
						path: 'organisation',
						element: (
							<ProtectedRoute>
								<OrganizationInfo />
							</ProtectedRoute>
						),
					},
					{
						path: 'subscription',
						element: (
							<ProtectedRoute>
								<SubscriptionLayout />
							</ProtectedRoute>
						),
					},
					{
						path: 'subscription-plans',
						element: (
							<ProtectedRoute>
								<SubscriptionPlans />
							</ProtectedRoute>
						),
					},
					{
						path: 'billing',
						element: <ComingSoon />, // TODO: Wrap in <ProtectedRoute> when ready
					},
					{
						path: 'profile-settings',
						element: <ProfileSettings />,
					},
				],
			},

			// copilot
			{
				path: 'copilot-subscriptions',
				element: <DashboardLayout />,
				children: [
					{
						index: true,
						element: <CopilotPage />,
					},

					{
						// index: true,
						path: 'subscribe',
						element: <CopilotSubscribe />,
					},
					{
						path: 'completion',
						element: <CopilotCompletion />,
					},
				],
			},
		],
	},
	// 404
	{
		path: '*',
		element: <NotFound />,
	},
]);
